import { render, staticRenderFns } from "./Aarselever.vue?vue&type=template&id=ab4dbe70&"
import script from "./Aarselever.vue?vue&type=script&lang=ts&"
export * from "./Aarselever.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports